import React from 'react'
import styled from 'styled-components'
import colors from '@constants/colors'

import {
    DANCE_STATUS_ORDERED,
    DANCE_STATUS_APPROVED,
    DANCE_STATUS_EXISTS,
} from '@components/AddEditDance/StatusProgressButton'

export default ({ status }) => {
    const getBackgroundColor = () => {
        switch (status) {
            case DANCE_STATUS_ORDERED:
                return 'orange'
                break

            case DANCE_STATUS_APPROVED:
                return 'yellow'
                break

            case DANCE_STATUS_EXISTS:
                return 'green'
                break

            default:
                break
        }
    }
    const textColor =
        status === DANCE_STATUS_APPROVED ? '#000' : colors.APP_WHITE

    return (
        <LabelContainer
            backgroundColor={getBackgroundColor()}
            textColor={textColor}
        >
            {status}
        </LabelContainer>
    )
}

const LabelContainer = styled.div`
    display: inline-block;
    padding: 0px 4px;
    border-radius: 2px;
    white-space: nowrap;
    align-self: flex-start;
    color: ${(p) => p.textColor};
    background-color: ${(p) => p.backgroundColor};
`
